import { registerPageTranslations } from "@ncino/pax-ui";
import type { FlatNamespace } from "i18next";

// Pages excluded from eager auto-discovery: their locale bundle is registered
// lazily in their route loader (see the matching route.tsx), keeping the JSON
// out of the initial chunk. The negative glob patterns below must stay in sync
// with the loaders that call registerPageTranslations.
const eagerLocales = import.meta.glob<{ default: Record<string, unknown> }>(
  [
    "./routes/*/locales/en_US.json",
    "!./routes/manage/locales/en_US.json",
    "!./routes/sell/locales/en_US.json",
  ],
  { eager: true }
);

for (const [path, mod] of Object.entries(eagerLocales)) {
  const ns = path.match(/routes\/([^/]+)\/locales/)?.[1];
  if (!ns) continue;
  registerPageTranslations(ns as FlatNamespace, { en_US: mod.default });
}
